<template>
  <div>
    <template v-if="show_group">
      <div class="w-100 px-4 py-3 position-absolute w-100 z-index-1041" style="top:0;">
        <div class="row slim-grid-row">
          <div class="col-10">
            <div class="w-100 bg-white border-semi-grey rounded-4">
              <div v-if="is_load" class="py-2">
                <loader /> 
              </div>
              <template v-else> 
                <div v-if="error != ''" class="row justify-content-center">
                  <div class="col-4">
                    <ErrorMessage :message="error" />
                  </div>
                </div>
                <template v-else>
                  <div class="row no-gutters">
                    <div class="col-2 text-center">
                      <div class="py-3">
                        <svg style="top:-3px" class="position-relative" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div class="col-10 my-2" @click="toggleBackdrop('merchant')">
                      <p class="mb-0 text-11 font-regular color-grey-ota">{{ getMerchant.name }}</p>
                      <p class="mb-0 text-14 font-bold text-semi-dark">{{ $formatDateRange(getBeFilter.date.check_in,getBeFilter.date.check_out,'YYYY-MM-DD','YYYY-MM-DD') }} <svg class="mx-1" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="2" height="2" rx="1" fill="#222"/></svg> {{ total_guests }}</p>
                    </div>
                  </div>

                  <div class="w-100">
                    <MerchantFilter ref="merchant_filter" :backdrop="backdrop_for" :merchant_list="merchant_list" @toggleBackdrop="toggleBackdrop" @applyFilter="applyFilter"/>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="col-2">
            <div class="w-100 bg-white border-semi-grey rounded-4 cursor-pointer" @click="toggleOtherMenu" style="padding: 18px 0px;">
              <div class="hamburger d-table mx-auto">
                <div class="one"></div>
                <div class="two"></div>
                <div class="three"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <popup-detail 
        direction="right" 
        :show="show_other_menu"
        :size="100"
        :height="100"
        title="Other Menu"
        @close="toggleOtherMenu">
        <template v-slot:body>
          <div class="px-4 pb-4 pt-2">
            <div class="d-block cursor-pointer py-3" @click="callClick">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Calling.png" 
                width="24"
                :alt="getMerchant.name">
                <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
            </div>
            <router-link :to="'/'+getMerchant.code+'/feedback'" class="d-block py-3" @click.native="$postLog('HOME','NAVBAR','Clicked menu review')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Star.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.review')}}</p>
            </router-link>
            <router-link :to="'/'+getMerchant.code+'/gallery'" class="d-block py-3" @click.native="$postLog('HOME','NAVBAR','Clicked menu gallery')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Image.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.gallery')}}</p>
            </router-link>
            <div class="d-block py-3 cursor-pointer" @click="shareClick()">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Send.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.share')}}</p>
            </div>
            <div v-if="isNotLogin" class="d-block cursor-pointer py-3">
              <router-link :to="'/'+getMerchant.code+'/login'">
                <img 
                  src="../../../../assets/img/icon/menu-navbar/Login.png" 
                  width="24"
                  :alt="getMerchant.name">
                <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
              </router-link>
            </div>
            <router-link :to="'/'+getMerchant.code+'/login'" class="my-auto d-block py-3" v-if="!isNotLogin">
              <div class="my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
                <img :src="getCurrentUser.avatar" :alt="getMerchant.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
              </div>
              <p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
            </router-link>
            <template>
              <router-link :to="'/'+getMerchant.code+'/booking'" class="d-block my-3" v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine">
                <button type="button" class="g-btn g-btn-primary g-btn-lg px-5">{{$t('hotel.action.book-now')}}</button>
              </router-link>
            </template>
          </div>
          <div class="mt-5 px-4 text-center">
            <p class="mb-2 font-semibold text-16 text-color-dark">{{getMerchant.address}}</p>
            <p class="mb-2 font-semibold text-16 text-color-dark">
              <a :href="'tel:'+getMerchant.phone" target="_blank" class="color-black">
                <u>{{getMerchant.phone}}</u>
              </a>
            </p>
            <p class="mb-2 font-semibold text-16 text-color-dark">
              <a :href="'mailto:'+getMerchant.email" target="_blank" class="color-black">
                <u>{{getMerchant.email}}</u>
              </a>
            </p>
            <template>
              <div class="mt-4">
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.whatsapp_number != '' && getMerchant.whatsapp_number != null">
                  <a :href="'https://api.whatsapp.com/send/?phone='+maskingPlusChar(getMerchant.whatsapp_number)+'&text&app_absent=0'" target="_blank">
                    <img src="../../../../assets/img/icon/social/whatsapp.svg" class="cursor-pointer social-img" width="35" title="Whatsapp">
                    <img src="../../../../assets/img/icon/social/blur/whatsapp.svg" class="cursor-pointer social-img-blur" width="35" title="Whatsapp">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.facebook_link != '' && getMerchant.facebook_link != null">
                  <a :href="getMerchant.facebook_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/facebook.svg" class="cursor-pointer social-img" width="35" title="Facebook">
                    <img src="../../../../assets/img/icon/social/blur/facebook.svg" class="cursor-pointer social-img-blur" width="35" title="Facebook">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.instagram_link != '' && getMerchant.instagram_link != null">
                  <a :href="getMerchant.instagram_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/instagram.svg" class="cursor-pointer social-img" width="35" title="Instagram">
                    <img src="../../../../assets/img/icon/social/blur/instagram.svg" class="cursor-pointer social-img-blur" width="35" title="Instagram">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tiktok_link != '' && getMerchant.tiktok_link != null">
                  <a :href="getMerchant.tiktok_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
                    <img src="../../../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tripadvisor_link != '' && getMerchant.tripadvisor_link != null">
                  <a :href="getMerchant.tripadvisor_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/tripadvisor.svg" class="cursor-pointer social-img" width="35" title="Tripadvisor">
                    <img src="../../../../assets/img/icon/social/blur/tripadvisor.svg" class="cursor-pointer social-img-blur" width="35" title="Tripadvisor">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.youtube_link != '' && getMerchant.youtube_link != null">
                  <a :href="getMerchant.youtube_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/youtube.svg" class="cursor-pointer social-img" width="35" title="Youtube">
                    <img src="../../../../assets/img/icon/social/blur/youtube.svg" class="cursor-pointer social-img-blur" width="35" title="Youtube">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.website != '' && getMerchant.website != null">
                  <a :href="getMerchant.website" target="_blank">
                    <img src="../../../../assets/img/icon/social/website.svg" class="cursor-pointer social-img" width="35" title="Website">
                     <img src="../../../../assets/img/icon/social/blur/website.svg" class="cursor-pointer social-img-blur" width="35" title="Website">
                  </a> 
                </div>
              </div>
            </template>
          </div>
        </template>
      </popup-detail>
    </template>
    <template v-else>
      <template v-if="$route.name == 'MerchantHome'">
        <div class="nav-mobile-be p-4" :class="{'position-relative bg-white box-shadow-nav':getMerchant.merchant_images.length == 0}">
          <div class="row">
            <div class="col-12 text-right">
              <img :src="getMerchant.image_url" :alt="getMerchant.name" width="40" class="float-left" v-if="getMerchant.merchant_images.length == 0">
              <div class="box-nav d-inline-block cursor-pointer" :class="{'border':getMerchant.merchant_images.length == 0}" @click="callClick()">
                <img src="../../../../assets/img/icon/menu-navbar/Calling.png" alt="Calling" width="18">
              </div>
              <div class="box-nav d-inline-block mx-1 cursor-pointer" :class="{'border':getMerchant.merchant_images.length == 0}" @click="shareClick()">
                <img src="../../../../assets/img/icon/menu-navbar/Send.png" alt="Send" width="18">
              </div>
              <router-link :to="'/'+getMerchant.code+'/gallery'" @click.native="$postLog('HOME','NAVBAR','Clicked menu gallery')">
                <div class="box-nav d-inline-block mx-1 cursor-pointer" :class="{'border':getMerchant.merchant_images.length == 0}">
                  <img src="../../../../assets/img/icon/menu-navbar/Image.png" alt="Send" width="18">
                </div>
              </router-link>
              <router-link class="box-nav d-inline-block cursor-pointer" :class="{'border':getMerchant.merchant_images.length == 0}" v-if="isNotLogin" :to="'/'+getMerchant.code+'/login'">
                <img src="../../../../assets/img/icon/menu-navbar/Login.png" alt="Login" width="18">
              </router-link>
              <router-link class="box-nav p-0 d-inline-block cursor-pointer" :class="{'border':getMerchant.merchant_images.length == 0}" v-else :to="'/'+getMerchant.code+'/account'">
                <img :src="getCurrentUser.avatar" alt="Login" class="w-100 rounded-100 top-0 left-0 object-fit" style="padding: 1px;" height="40">
              </router-link>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- NAVBAR -->
        <header class="header-fixed bg-white z-index-1040">
          <div class="px-10">
            <div class="row">
              <div class="col-4 col-md-2">
                <img :src="getMerchant.image_url" width="70" :alt="getMerchant.name">
              </div>
              <div class="col-8 col-md-10 text-right">
                <div class="text-right show-mobile">
                  <div class="mt-3 pt-1" @click="headerMobile()">
                    <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="4" width="18" height="2" rx="1" fill="#222222"/>
                      <rect y="6" width="22" height="2" rx="1" fill="#222222"/>
                      <rect x="4" y="12" width="18" height="2" rx="1" fill="#222222"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <!-- HEADER MOBILE -->
        <div class="w-100 fixed-top" style="top: 80px;">
          <b-row class="justify-content-center" no-gutters>
            <b-col cols="12">
              <div class="bg-white px-7 pb-4 w-100 h-100vh pop-up-body z-index-1040 position-relative border-top pt-2" v-if="responsive.mobile_header">
                <div class="mt-2">
                  <div :class="{'pt-3':!getMerchant.use_booking_engine && !isNotLogin, 'pt-3 position-relative top--1':!isNotLogin}">
                    <div class="d-block px-4 py-3 w-100" @click="callClick">
                      <img 
                        src="../../../../assets/img/icon/menu-navbar/Calling.png" 
                        width="24"
                        :alt="getMerchant.name">
                        <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
                    </div>
                    <router-link :to="'/'+getMerchant.code+'/feedback'" class="d-block px-4 py-3 w-100" @click.native="$postLog('HOME','NAVBAR','Clicked menu review')">
                      <img 
                        src="../../../../assets/img/icon/menu-navbar/Star.png" 
                        width="24"
                        :alt="getMerchant.name">
                      <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.review')}}</p>
                    </router-link>
                    <router-link :to="'/'+getMerchant.code+'/gallery'" class="d-block px-4 py-3 w-100" @click.native="$postLog('HOME','NAVBAR','Clicked menu gallery')">
                      <img 
                        src="../../../../assets/img/icon/menu-navbar/Image.png" 
                        width="24"
                        :alt="getMerchant.name">
                      <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.gallery')}}</p>
                    </router-link>
                    <div class="d-block px-4 py-3 w-100" @click="shareClick()">
                      <img 
                        src="../../../../assets/img/icon/menu-navbar/Send.png" 
                        width="24"
                        :alt="getMerchant.name">
                      <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.share')}}</p>
                    </div>
                    <div v-if="isNotLogin" class="d-block px-4 py-3 w-100">
                      <router-link :to="'/'+getMerchant.code+'/login'">
                        <img 
                          src="../../../../assets/img/icon/menu-navbar/Login.png" 
                          width="24"
                          :alt="getMerchant.name">
                        <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
                      </router-link>
                    </div>
                  </div>
                  <div class="py-2 my-1">
                    <router-link :to="'/'+getMerchant.code+'/login'" class="my-auto" v-if="!isNotLogin">
                      <div class="ml-4 my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
                        <img :src="getCurrentUser.avatar" :alt="getMerchant.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
                      </div>
                      <p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
                    </router-link>
                  </div>
                  <div class="py-3">
                    <template >
                      <router-link :to="'/'+getMerchant.code+'/booking'" class="ml-4" v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine">
                        <button type="button" class="g-btn g-btn-primary g-btn-lg px-5">{{$t('hotel.action.book-now')}}</button>
                      </router-link>
                    </template>
                  </div>
                </div>
                <div class="mt-8 px-4 text-center">
                  <p class="mb-2 font-semibold text-16 text-color-dark">{{getMerchant.address}}</p>
                  <p class="mb-2 font-semibold text-16 text-color-dark">
                    <a :href="'tel:'+getMerchant.phone" target="_blank" class="color-black">
                      <u>{{getMerchant.phone}}</u>
                    </a>
                  </p>
                  <p class="mb-2 font-semibold text-16 text-color-dark">
                    <a :href="'mailto:'+getMerchant.email" target="_blank" class="color-black">
                      <u>{{getMerchant.email}}</u>
                    </a>
                  </p>
                  <template>
                    <div class="mt-4">
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.whatsapp_number != '' && getMerchant.whatsapp_number != null">
                        <a :href="'https://api.whatsapp.com/send/?phone='+maskingPlusChar(getMerchant.whatsapp_number)+'&text&app_absent=0'" target="_blank">
                          <img src="../../../../assets/img/icon/social/whatsapp.svg" class="cursor-pointer social-img" width="35" title="Whatsapp">
                          <img src="../../../../assets/img/icon/social/blur/whatsapp.svg" class="cursor-pointer social-img-blur" width="35" title="Whatsapp">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.facebook_link != '' && getMerchant.facebook_link != null">
                        <a :href="getMerchant.facebook_link" target="_blank">
                          <img src="../../../../assets/img/icon/social/facebook.svg" class="cursor-pointer social-img" width="35" title="Facebook">
                          <img src="../../../../assets/img/icon/social/blur/facebook.svg" class="cursor-pointer social-img-blur" width="35" title="Facebook">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.instagram_link != '' && getMerchant.instagram_link != null">
                        <a :href="getMerchant.instagram_link" target="_blank">
                          <img src="../../../../assets/img/icon/social/instagram.svg" class="cursor-pointer social-img" width="35" title="Instagram">
                          <img src="../../../../assets/img/icon/social/blur/instagram.svg" class="cursor-pointer social-img-blur" width="35" title="Instagram">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tiktok_link != '' && getMerchant.tiktok_link != null">
                        <a :href="getMerchant.tiktok_link" target="_blank">
                          <img src="../../../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
                          <img src="../../../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tripadvisor_link != '' && getMerchant.tripadvisor_link != null">
                        <a :href="getMerchant.tripadvisor_link" target="_blank">
                          <img src="../../../../assets/img/icon/social/tripadvisor.svg" class="cursor-pointer social-img" width="35" title="Tripadvisor">
                          <img src="../../../../assets/img/icon/social/blur/tripadvisor.svg" class="cursor-pointer social-img-blur" width="35" title="Tripadvisor">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.youtube_link != '' && getMerchant.youtube_link != null">
                        <a :href="getMerchant.youtube_link" target="_blank">
                          <img src="../../../../assets/img/icon/social/youtube.svg" class="cursor-pointer social-img" width="35" title="Youtube">
                          <img src="../../../../assets/img/icon/social/blur/youtube.svg" class="cursor-pointer social-img-blur" width="35" title="Youtube">
                        </a> 
                      </div>
                      <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.website != '' && getMerchant.website != null">
                        <a :href="getMerchant.website" target="_blank">
                          <img src="../../../../assets/img/icon/social/website.svg" class="cursor-pointer social-img" width="35" title="Website">
                           <img src="../../../../assets/img/icon/social/blur/website.svg" class="cursor-pointer social-img-blur" width="35" title="Website">
                        </a> 
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
  import { mapGetters,mapMutations } from 'vuex';
  import { get } from '@/services/index.js'
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import MerchantFilter from '@/components/community/Filter'
  import moment from 'moment'
  import config from '@/config/index.js'
  
  export default{
    components:{
      MerchantFilter
    },
    data(){
      return{
        is_load: false,
				error: '',
        merchant_list: [],
        backdrop_for: '',
        filter_result: {},
        show_other_menu: false,
        responsive: {
          mobile_header: false,
        },
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getBeFilter','getCurrency','getCompanyType','isNotLogin','getRoomStay','getCurrentUser']),
      total_guests(){
				let total_guest = Number(this.getBeFilter.guest.adult)+Number(this.getBeFilter.guest.child)
				return `${total_guest} ${this.$pluralWord(total_guest,'Guest')}`
			},
      show_filter_top(){
        return false
      },
      show_group(){
        let community_id = this.getMerchant.community.id ? this.getMerchant.community.id : this.getMerchant.community

        let is_community_default = config.COMMUNITY_SYSTEM == community_id
        
        const is_allowed_community = () => {
          let allowed_community = ['coinfestasia', 'baliblockchainsummit', 'ghr']
          return allowed_community.some(x=> x == this.getMerchant.community.code)
        }

        const is_test_community = () => {
          let is_test = this.getMerchant.community.code.substring(0, 11)
          return is_test == 'testing-gp-'
        }  
        
        // return this.$app_env == 'dev' || (this.$app_env == 'prod' && config.COMMUNITY_SYSTEM != community_id) ? true : false 
        return this.$app_env == 'prod' && !is_community_default && !is_allowed_community() && !is_test_community()
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      toggleBackdrop(data=''){
				this.backdrop_for = data
	    },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        if(this.show_group){
          this.loadMerchantList().catch(err=>this.error = err).finally(()=>this.is_load=false)
        }
      },
      loadMerchantList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY','merchant-list',{
      			community_id: this.getMerchant.community.id,
      			merchant_type:  'hotel'
      		}).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.merchant_list = res.data
              this.merchant_list.unshift({
                name: this.$t('hotel.all-property'),
                id: 'all'
              })
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
      customFormatDate(date,format){
				return moment(date).format(format)
			},
      applyFilter(data){
        this.filter_result = {
          check_in_date: this.customFormatDate(data.date.startDate,'YYYY-MM-DD'),
          check_out_date: this.customFormatDate(data.date.endDate,'YYYY-MM-DD'),
          promo_code: data.promo_code,
          adult: data.guest.adult,
          child: data.guest.child,
          infant: data.guest.infant
        }
        if((data.merchant.id && data.merchant.id == 'all') || !data.merchant.id){
          this.goToGroup()
        }else{
          if(data.merchant.id != this.getMerchant.id){
            let params = `hotel-filter-redirect/${this.filter_result.check_in_date}/${this.filter_result.check_out_date}`
            if(this.filter_result.promo_code != ''){
              params += `/${this.filter_result.promo_code}`
            }else{
              params += '/promo_code_empty'
            }
            params += `?guest=${this.filter_result.adult}-${this.filter_result.child}-${this.filter_result.infant}`
            let merchant_url = `${window.location.origin}/${data.merchant.code}/${params}`
            window.open(merchant_url,'_self')
          }else{
            let params = {
              date: {
                check_in: data.date.startDate,
                check_out: data.date.endDate,
              },
              guest: data.guest,
              promo_code: data.promo_code,
            }
            this.setBeFilter(params)
            this.$router.push(`/${this.getMerchant.code}/booking`)
          }
        }
      },
      goToGroup(){
        let community_url = `${window.location.origin}/${this.getMerchant.community.code}/group`
        window.open(community_url,'_self')
      },
      toggleOtherMenu(){
        this.show_other_menu = !this.show_other_menu
      },
      shareClick(){
        this.$emit("shareClick")
      },
      callClick(){
				this.$emit('callClick')
			},
      headerMobile(){
        this.responsive.mobile_header = !this.responsive.mobile_header
      },
      maskingPlusChar(data){
        let return_data = data.substring(0,1)
        return return_data == '+' ? data.substring(1,data.length) : data
      }
    }
  }
</script>
<style scoped>
.show-desktop{
  display: block;
}
.show-mobile{
  display: none;
}
.hide-576px{
  display: block;
}
.header-fixed{
  position: fixed;
  width: 100%;
  top: -1px;
  height: 80.8px;
  background-color: #fff;
  z-index: 9;
}
@media screen and (max-width: 1200px) {
  .show-desktop{
    display: none;
  }
  .show-mobile{
    display: block;
  }
  .px-10{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media screen and (max-width: 576px) {
  .hide-576px{
    display: none;
  }
  .px-10{
    padding-left: 24px;
    padding-right: 24px;
  }
  .text-20-m{
    font-size: 20px!important;
  }
  .text-17-m{
    font-size: 17px!important;
  }
  .text-14-m{
    font-size: 14px!important;
  }
  .room-type-border-m{
    border: 1px solid #ddd;
    padding-bottom: 0px!important;
    border-radius: 6px;
  }
  .room-type-desc-m{
    padding: 16px!important;
  }
  .p-0-m{
    padding: 0!important;
  }
  .h-270px-m{
    height: 270px!important;
  }
  .px-7{
    padding-left: 0!important;
    padding-right: 0!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/HomeNavbar.vue